import { render, staticRenderFns } from "./select_margin_calculation.vue?vue&type=template&id=b9966f62"
import script from "./select_margin_calculation.vue?vue&type=script&lang=js"
export * from "./select_margin_calculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports